/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Setclip_Is_ActiveInputs */

const en_forms_users_settings_setclip_is_active = /** @type {(inputs: Forms_Users_Settings_Setclip_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is always active`)
};

const de_forms_users_settings_setclip_is_active = /** @type {(inputs: Forms_Users_Settings_Setclip_Is_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist immer aktiv`)
};

/**
* | output |
* | --- |
* | "Is always active" |
*
* @param {Forms_Users_Settings_Setclip_Is_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_setclip_is_active = /** @type {((inputs?: Forms_Users_Settings_Setclip_Is_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Setclip_Is_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_setclip_is_active(inputs)
	return de_forms_users_settings_setclip_is_active(inputs)
});